import {colors} from "@c10h/colors";
import {Trans, useTranslation} from "ni18n";
import React from "react";

import {useTypedSelector} from "../../../store/index";
import useMediaQuery from "../../../useMediaQuery";
import {IllustratedTextDecoration} from "../IllustratedTextDecoration";
import {Btn} from "../V5Comp";
import {CoronavirusSection} from "./Section";

type Props = {
  sections: CoronavirusSection[];
};

const Overview: React.FC<Props> = ({sections}) => {
  const i18n = useTranslation();
  /*
    Currently turning off text decorations for mobile because they do not render properly.
    Inline styles are not getting passed to the <img> element with iPhone user agent.
  */
  const {isMobile} = useTypedSelector(state => state.config);
  const isMd = useMediaQuery("md");
  return (
    <div className="pt40 pb20 pt24-md pb5-md ph4">
      <div className="maxw40 maxw25-md ma df fdc tac">
        <h1 className="mb4 fs28-md pos-r">
          {isMd ? (
            <Trans>
              <span className="mr2">COVID-19 Resources to keep you</span>
              <span className="pos-r darkerGreen">
                <span className="zIndex2 pos-r">
                  healthy{" "}
                  {!isMobile && (
                    <IllustratedTextDecoration
                      type="blue-underline"
                      className="zIndex1"
                      style={{bottom: -1}}
                      aria-hidden
                    />
                  )}
                </span>
                and{" "}
                <span className="pos-r">
                  safe
                  {!isMobile && (
                    <IllustratedTextDecoration
                      type="blue-underline"
                      className="zIndex1"
                      style={{bottom: 2}}
                      aria-hidden
                    />
                  )}
                </span>
              </span>
            </Trans>
          ) : (
            <Trans>
              <span className="mr2">COVID-19 Resources to keep you</span>
              <span className="pos-r">
                <span className="darkerGreen zIndex2 pos-r">healthy and safe</span>
                <IllustratedTextDecoration
                  type="blue-underline"
                  className="zIndex1"
                  style={{bottom: -4}}
                  aria-hidden
                />
              </span>
            </Trans>
          )}
        </h1>
        <h2 className="fs20 fs18-md ls-3">
          {i18n.t("Explore our tools and offerings for life, work, travel and beyond.")}
        </h2>
        <span className="dn dib-md fs28 font-csb mt10">{i18n.t("How can we help?")}</span>
        <ul className="df fw aic jcc fwnw-md fdc-md mt10 mt4-md gg3">
          {sections.map(({id, smallTitle, icon, href}) => (
            <li key={id} className="t-150" data-cy={id}>
              <Btn
                href={href || `#${id}`}
                color={colors.gray800}
                hover="#fff"
                bg={colors.gray100}
                hoverBg={colors.gray800}
                className="pos-r focus-bsDarkBlue3"
                onClick={() => {
                  // @ts-expect-error TS2531: Object is possibly 'null'.
                  if (!href) document.getElementById(id).focus();
                }}
              >
                <span
                  className={`cIcon-${icon} fs22 pos-a`}
                  style={{left: 16, top: "50%", transform: "translateY(-50%)"}}
                  aria-hidden
                />
                <span className="font-ib ml5">{smallTitle}</span>
              </Btn>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Overview;
